import { Link } from 'react-router-dom'
import { FaHome, FaBook, FaVideo, FaUsb, FaLaptop } from 'react-icons/fa'

const Navbar = () => {
  return (
    <nav className="bg-white shadow border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex justify-between items-center">
        <Link to="/" className="text-2xl font-bold text-primary flex items-center">
          <img src="/favicon.svg" alt="装个机" className="w-8 h-8 mr-2" />
          装个机™
        </Link>
        <ul className="flex space-x-6 text-sm sm:text-base text-gray-600">
          <li>
            <Link to="/" className="nav-link flex items-center">
              <FaHome className="mr-1" />
              首页
            </Link>
          </li>
          <li>
            <Link to="/guide/windows" className="nav-link flex items-center">
              <FaBook className="mr-1" />
              指南
            </Link>
          </li>
          <li>
            <Link to="/videos" className="nav-link flex items-center">
              <FaVideo className="mr-1" />
              视频
            </Link>
          </li>
          <li>
            <Link to="/usb-recommend" className="nav-link flex items-center">
              <FaUsb className="mr-1" />
              U盘推荐
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  )
}

export default Navbar 